module.exports = "/_next/static/images/idnes-logo-44dc0d4941c57d8653fb9196259735c3.jpg";